import script from "./SelectArtwork.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectArtwork.vue?vue&type=script&setup=true&lang=js"

import "./SelectArtwork.vue?vue&type=style&index=0&id=c5914434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5914434"]])

export default __exports__